import React, { useState } from "react"
import * as v2layouts from "../layouts"

interface TrainingModalProps {
	title: string
	assetCount: number
	assetTypes: Set<string>
	onConfirm: (isOnBrand: boolean, destination: string) => void
	onCancel: () => void
}

export function TrainingModal({ title, assetCount, assetTypes, onConfirm, onCancel }: TrainingModalProps): JSX.Element {
	const [isOnBrand, setIsOnBrand] = useState(true)
	const [destination, setDestination] = useState("")

	const hasImages = assetTypes.has("image")
	const hasText = assetTypes.has("text")

	const getDestinationOptions = (): { value: string; label: string }[] => {
		if (hasImages && hasText) {
			return [
				{ value: "image", label: "Image Training" },
				{ value: "text", label: "Text Training" },
			]
		}
		if (hasImages) {
			return [{ value: "image", label: "Image Training" }]
		}
		if (hasText) {
			return [{ value: "text", label: "Text Training" }]
		}
		return []
	}

	const destinationOptions = getDestinationOptions()

	const handleConfirm = (): void => {
		if (!destination) return
		onConfirm(isOnBrand, destination)
	}

	return (
		<v2layouts.Modal onClick={onCancel}>
			<v2layouts.ModalContent onClick={(e) => e.stopPropagation()} style={{ maxWidth: "500px" }}>
				<v2layouts.ModalTitle>{title}</v2layouts.ModalTitle>

				<div style={{ marginBottom: "20px" }}>
					<p style={{ marginBottom: "16px", fontSize: "14px", color: "#616161", lineHeight: "1.6" }}>
						Send {assetCount} asset{assetCount > 1 ? "s" : ""} to training as examples to improve scoring models.
					</p>

					<div style={{ marginBottom: "20px" }}>
						<label style={{ display: "block", marginBottom: "8px", fontWeight: 500, fontSize: "13px", color: "#616161" }}>
							Brand Alignment
						</label>
						<div style={{ display: "flex", gap: "12px" }}>
							<button
								onClick={() => setIsOnBrand(true)}
								style={{
									flex: 1,
									padding: "12px",
									border: `2px solid ${isOnBrand ? "#1976d2" : "#e0e0e0"}`,
									borderRadius: "4px",
									background: isOnBrand ? "#e3f2fd" : "white",
									cursor: "pointer",
									fontWeight: 500,
									color: isOnBrand ? "#1976d2" : "#616161",
								}}
							>
								On-Brand
							</button>
							<button
								onClick={() => setIsOnBrand(false)}
								style={{
									flex: 1,
									padding: "12px",
									border: `2px solid ${!isOnBrand ? "#d32f2f" : "#e0e0e0"}`,
									borderRadius: "4px",
									background: !isOnBrand ? "#ffebee" : "white",
									cursor: "pointer",
									fontWeight: 500,
									color: !isOnBrand ? "#d32f2f" : "#616161",
								}}
							>
								Off-Brand
							</button>
						</div>
					</div>

					<div>
						<label style={{ display: "block", marginBottom: "8px", fontWeight: 500, fontSize: "13px", color: "#616161" }}>
							Training Destination
						</label>
						<v2layouts.Select value={destination} onChange={(e) => setDestination(e.target.value)}>
							<option value="">Select destination...</option>
							{destinationOptions.map((opt) => (
								<option key={opt.value} value={opt.value}>
									{opt.label}
								</option>
							))}
						</v2layouts.Select>
						{hasImages && hasText && (
							<v2layouts.HelpText>
								Image assets go to Image training. Text assets go to Text training.
							</v2layouts.HelpText>
						)}
					</div>
				</div>

				<v2layouts.ButtonGroup>
					<v2layouts.ActionButton onClick={onCancel}>Cancel</v2layouts.ActionButton>
					<v2layouts.ActionButton $variant="primary" disabled={!destination} onClick={handleConfirm}>
						Send to Training
					</v2layouts.ActionButton>
				</v2layouts.ButtonGroup>
			</v2layouts.ModalContent>
		</v2layouts.Modal>
	)
}
